import React, { } from 'react'
import {
    View, Text, Image, Pressable,
    TouchableOpacity, Animated
} from 'react-native'
import { Tooltip } from 'react-native-elements';
import { useRoute } from '@react-navigation/native';

import { onPressA2HS } from '../../services/A2HSUtils';
import { checkIsAddressCompleted } from '../../services/user/UserAddressUtils';
import { constrainOverflowingView, getImagePath } from '../../services/CommonUtils';

import { IconView } from './Icons';
import { CartIconView } from './CartIconView';
import { CancelOrder, RateOrder } from '../oms/OMSWidget';
import { LocationIconView } from '../Location/Location-Widget';
import { AddMember, CallPharmacy, CommonBackIcon, SupportView } from '../Common-Widget';

import { LocationName } from '../../constants/ConstantsMapping';

import AppTheme from '../../../AppTheme';
import AppStyles from '../../../AppStyles';
import disableScroll from 'disable-scroll';
import TextStyle from '../../../TextStyle';

export const CommonHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    const title = props.title ?? ''
    return (
        <View style={[AppStyles.header]}>
            <View style={[AppStyles.flexRow]}>
                {CommonBackIcon(props)}
                <Text style={TextStyle.text20xb}>{title}</Text></View>
        </View>)
}

export const EmptyHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header, {
            backgroundColor: AppTheme.color.transparent,
            borderBottomColor: AppTheme.color.transparent,
            shadowColor: AppTheme.color.transparent,
        }]} />)
}


export const CommonTooltipHeader = (props) => {
    const title = props?.title ?? ''
    const location = props?.selectedLocation
    const showBackIcon = props.showBackIcon ?? false
    const toolTipView = props.toolTipView
    const toolTipContainerView = props.toolTipContainerView
    const locationIconView = props.locationIconView
    const toolTipMaxViewWidth = props?.toolTipMaxViewWidth ?? AppTheme.appWidth / 2 + 32
    return (<View style={[AppStyles.header, AppStyles.pr16]}>
        <View style={AppStyles.flexRowStart}>
            {showBackIcon ? CommonBackIcon(props) : <View style={{ width: 16 }} />}
            <Text style={[TextStyle.text20xb]}>
                {title}</Text>
        </View>
        {checkIsAddressCompleted(location) && <View style={AppStyles.flexRowEnd}>
            <Tooltip withOverlay={false}
                popover={toolTipContainerView()}
                // skipAndroidStatusBar={true}
                width={null} height={null}
                // closeOnlyOnBackdropPress={true}
                containerStyle={{
                    left: "auto", right: 16 + constrainOverflowingView(),
                    maxWidth: toolTipMaxViewWidth
                }} backgroundColor={AppTheme.color.black}>
                {toolTipView()}
            </Tooltip>
            {locationIconView()}
        </View>}
    </View>)
}

export const CommonSupportHeader = (props) => {
    return (<View style={[AppStyles.header, AppStyles.px16]}>
        <View style={AppStyles.flexRowStart}>
            {props?.showBackpress && CommonBackIcon(props)}
            <Text style={TextStyle.text20xb}>{props.title}</Text>
        </View>
        <SupportView showSupportModal={props.showSupportModal} />
    </View>)
}

// Tab Controller
export const CommonScreenTitle = (props) => {
    return (
        <View style={[AppStyles.header, AppStyles.px16]}>
            <Text style={TextStyle.text20xb}>{props.title}</Text>
        </View>)
}

export const CommonPharmacyHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header, AppStyles.pr16]}>
            <View style={[AppStyles.flexRow]}>
                {CommonBackIcon(props)}
                <Text ellipsizeMode="head" numberOfLines={1}
                    style={[TextStyle.text20xb, { width: AppTheme.appWidth - (55 + 18 + 16), textAlign: 'left' }]}>
                    {props.title}</Text></View>
            {CallPharmacy(props.pharmacyData, '/images/icons/call_blue.svg')}
        </View>)
}

export const CommonAddMemberHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header, AppStyles.pr16]}>
            <View style={[AppStyles.flexRow]}>
                {CommonBackIcon(props)}
                <Text style={TextStyle.text20xb}>{props.title}</Text></View>
            {AddMember(props.addMember)}
        </View>)
}

// Complete profile
export const CommonLoginHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header]}>
            <View style={[AppStyles.flexRow]}>
                {CommonBackIcon(props)}
                <IconView icon={'medcords_aayu.svg'}
                    iconStyle={{ marginLeft: 16 }} height={28} width={98}
                />
            </View>
        </View>)
}

export const OrderSummaryHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header, AppStyles.pr16]}>
            <View style={[AppStyles.flexRow]}>
                {CommonBackIcon(props)}
                <Text style={TextStyle.text20xb}>{props.title}</Text></View>
            {props.showRateBtn ? <RateOrder action={props.showRateOrderModal} /> : null}
            {props.showCancelBtn ? <CancelOrder cancelOrder={props.cancelOrder} /> : null}
        </View>)
}

export const A2hsView = (props) => {
    return (
        <View style={[AppStyles.flexRowCenter, { alignContent: "flex-end", borderWidth: 2, borderRadius: 50, padding: 8 }]}>
            <TouchableOpacity style={{ paddingLeft: 4 }} onPress={() => { onPressA2HS() }}>
                <IconView icon={'save_to_home_screen.svg'}
                    iconStyle={{ marginRight: 3 }} width={14} height={19.5} />
            </TouchableOpacity>
        </View>)

}

export const CommonLocationHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return (
        <View style={[AppStyles.header,
        AppStyles.pr16,
        { paddingVertical: 6, minHeight: 52 }]}>
            {props?.storeProfileLoaded ? null :
                CommonBackIcon(props)}
            <Pressable onPress={() => {
                props?.pharmacyPage ||
                    props?.storeProfileLoaded ? null :
                    props?.onClickBottomChevron()
            }}
                style={{
                    flex: 1,
                    flexGrow: 2,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: props?.storeProfileLoaded ? 16 : 0
                }}>
                {LocationIconView({ locationName: LocationName.other, height: 18, width: 18 })}
                <Text numberOfLines={1}
                    ellipsizeMode={'head'}
                    style={[TextStyle.text14xb,
                    {
                        maxWidth: AppTheme.appWidth * 0.6,
                        textAlign: 'left',
                        marginLeft: 4
                    }]}>
                    {props.title}</Text>
                {props?.pharmacyPage ||
                    props?.storeProfileLoaded ? null :
                    <Image style={{ marginRight: 16, marginLeft: 4 }}
                        source={{
                            uri: getImagePath(
                                '/images/oms/dark-chevron-down.svg'),
                            width: 12,
                            height: 7
                        }} />}
            </Pressable>

            {props?.pharmacyPage &&
                props?.storeProfileLoaded &&
                props?.isShowA2hsCta ? A2hsView(props) : null}

            {!!props?.hideCart ? null : <CartIconView action={props.cartNavigation} />}
        </View>)
}

export const CommonCartHeader = (props) => {
    const title = props?.title ?? ''
    const hideCart = props?.hideCart ?? false
    const cartNavigation = props?.cartNavigation
    return (<View style={[AppStyles.header, AppStyles.pr16, AppStyles.py8]}>
        <View style={[AppStyles.flexRowStart]}>
            {CommonBackIcon(props)}
            <Text ellipsizeMode="head" numberOfLines={1}
                style={[TextStyle.alignLeft, TextStyle.text20xb,
                { width: AppTheme.appWidth - (55 + 18 + 16 + 32 + 24) }]}>
                {title}</Text></View>
        {hideCart ? null : <CartIconView action={cartNavigation} cartItemCount={props.cartItemCount} />}
    </View>)
}

export const CommonSearchLocalityHeader = (props) => {
    disableScroll.off();
    const routeName = useRoute();
    global.lastHashCode = '/' + routeName.name;
    return <View style={[AppStyles.localityHeader]}>
        <View style={[AppStyles.flexRowSpaceBetween, AppStyles.pr16, { marginBottom: 12 }]}>
            {CommonBackIcon(props)}
            {props.textInputView()}
        </View>
        {props.currentLocationView()}
    </View>
}

export const CommonCategoryListHeader = (props) => {
    const hideCart = props?.hideCart ?? false
    const cartNavigation = props?.cartNavigation
    return <View style={[AppStyles.header, AppStyles.pr16, AppStyles.py8]}>
        <View style={[AppStyles.flexRowStart]}>
            {CommonBackIcon(props)}
            <props.TextInputView />
        </View>
        {hideCart ? null : <CartIconView action={cartNavigation} cartItemCount={props.cartItemCount} />}
    </View>
}

export const DashboardHeader = (props) => {
    disableScroll.off();
    return <View style={[AppStyles.flexRowSpaceBetween, AppStyles.header, AppStyles.p16]}>

        <Image source={{ uri: getImagePath('/images/icons/medcords_aayu.svg'), height: 28, width: 98 }} />

        {props.isShowA2hsCta ?
            <Animated.View style={[AppStyles.flexRowCenter, {
                alignContent: "flex-end", borderWidth: 2,
                width: props?.value?.interpolate({ inputRange: [0, 100], outputRange: ['0%', '100%'] }) ?? props?.width,
                maxWidth: props?.value?.interpolate({ inputRange: [0, 100], outputRange: ['0%', '100%'] }) ?? props?.width,
                borderColor: '#000000', borderRadius: 50, padding: 10, minWidth: 45
            }]}>
                <TouchableOpacity style={{ paddingLeft: 4 }} onPress={() => { props?.onPressA2HS() }}>
                    <Image style={{ marginRight: 3 }} source={{ uri: getImagePath('/images/icons/save_to_home_screen.svg'), width: 14, height: 19.5 }} />
                </TouchableOpacity>
                <Text onPress={() => { props?.onPressA2HS() }}
                    numberOfLines={1} style={[TextStyle.text14b, {}]}>
                    {' Add To Home Screen'}</Text>
            </Animated.View> : null}

    </View>
}